import { FeatureTags } from '@spazious/dollhouse-types';

/**
 * Creates a feature checker function that checks if a feature is enabled or not
 */
export const createFeatureChecker = (enabledFeatures: FeatureTags[]) => {
  return (features: FeatureTags | FeatureTags[]) => {
    const scopes = Array.isArray(features) ? features : [features];
    const granted = scopes.every((features) => enabledFeatures.includes(features));
    return granted;
  };
};
